"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    number: {
        format: {
            precision: 2,
            delimiter: '.',
            separator: ',',
        },
    },
    date: {
        formats: {
            short: '%d/%m/%Y',
            weekday: '%A',
            full: '%-d de %B de %Y',
        },
    },
    time: {
        formats: {
            short: '%H:%M',
            hour: '%-I%p',
        },
    },
    strings: {
        msg: {
            removeAccountConfirmation: 'Tem certeza que deseja remover sua conta? Sua solicitação será processada em até 24 horas úteis.',
            selectPlaceWithPostalCode: 'Necessário incluir o número do endereço ou realize a busca pelo CEP',
            successToApproveUser: 'Usuário aprovado com sucesso',
            successToRegisterUser: 'Usuário cadastrato com sucesso',
            successToReleaseMedicine: 'Medicamento liberado com sucesso',
            successToRemoveAccount: 'Sua solicitação foi enviada com sucesso. Aguarde o prazo para remoção dos seus dados.',
        },
        err: {
            accreditedNotFound: 'Nenhuma farmácia encontrada para o CEP especificado',
            existingPatientProcedure: 'Medicamento já liberado para esse paciente',
            failedToApproveUser: 'Falha ao aprovar usuário',
            failedToFindPatientProcedure: 'Falha ao buscar liberação de medicamento',
            failedToLoadData: 'Falha ao carregar dados',
            failedToLoadPharmacies: 'Falha ao buscar farmácias. Por favor, tente novamente ou entre em contato caso o problema persista.',
            failedToRegisterUser: 'Falha ao cadastrar usuário',
            failedToReleaseMedication: 'Falha ao liberar medicamento',
            failedToRequestOptout: 'Não foi possível solicitar a remoção dos seus dados. Por favor entre em contato.',
            failedToSearchDoctor: 'Falha ao buscar CRM',
            failedToSendCode: 'Não foi possível enviar o código por SMS. Verifique se o seu celular está correto',
            failedToSignup: 'Falha ao realizar cadastro',
            failedToUpdateProcedurePatient: 'Ocorreu um erro ao confirmar os dados. Por favor, tente novamente ou entre em contato caso o problema persista.',
            patientProcedureNotFound: 'Medicamento não liberado para seu CPF. Entre em contato com seu médico.',
        },
        title: {
            confirmApproval: 'Confirmar aprovação do usuário',
        },
        validation: {
            duplicatedCpf: 'CPF já cadastrado',
            emailMustMatch: 'Os e-mails devem ser iguais',
            invalidCpf: 'CPF inválido',
            invalidEmail: 'Email inválido',
            invalidField: 'Campo inválido',
            invalidPhone: 'Telefone inválido',
            minLength: 'Mínimo de {{length}} caracteres',
            passwordMustMatch: 'As senhas devem ser iguais',
            requiredField: 'Campo obrigatório',
            requiredPatientAcceptance: 'É necessário aceitar pelo menos uma das formas de contato',
            requiredTerms: 'É necessário aceitar os termos do programa',
        },
        navigation: {
            '/inventory': 'Estoque',
            '/medications/release': 'Liberar medicamento',
            '/users': 'Usuários',
            '/users/register': 'Cadastro de usuário',
            '/users/permissions': 'Controle de acesso ao medicamento',
        },
        placeholders: {},
        home: {
            title: 'Programa Primeira Caixa',
            subtitle: '',
            loginCaption: 'Clique aqui para acessar a plataforma caso já possua seu cadastro',
            signupCaption: 'Clique aqui para criar sua conta e se registrar no programa',
        },
        signup: {
            firstStep: {
                title: 'Vamos Começar Seu Cadastro',
                subtitle: 'DIGITE ABAIXO SEU CRM E A UF DE SUA INSCRIÇÃO',
            },
            secondStep: {
                title: 'Confira Seus Dados',
                subtitle: 'VERIFIQUE SE TODAS AS INFORMAÇÕES ESTÃO CORRETAS.',
                subtitle2: 'EM CASO DE CAMPOS VAZIOS, FAVOR PREENCHE-LOS PARA QUE O CADASTRO SEJA FINALIZADO.',
                acceptTerms: 'Confirmo que li e aceito os termos de uso',
                readTerms: 'Leia aqui nossos termos de uso',
                dialogCodeText: 'Enviamos um código de validação por SMS, por favor digite o código recebido',
            },
            thirdStep: {
                title: 'Confirme Seu Cadastro',
                subtitle: 'Enviamos um código de validação por SMS, por favor digite o código recebido',
            },
            fourthStep: {
                title: 'Cadastro Concluído com Sucesso',
                subtitle: 'Clique abaixo para efetuar o login na plataforma',
                signin: 'Acessar o sistema',
            },
        },
        medication: {
            release: {
                acceptSms: 'O paciente aceita receber por SMS as instruções para retirada do medicamento',
                acceptEmail: 'O paciente aceita receber por Email as instruções para retirada do medicamento',
            },
        },
        patientConfirmation: {
            firstStep: {
                title: 'Liberação de medicamento',
                titleLine2: '1ª caixa',
                subtitle: 'Confirme seu cadastro ou procure a farmácia mais próxima para adquirir seu medicamento',
                confirmRegistrationCaption: 'Clique aqui e complete seu cadastro para agilizar o tempo na farmácia escolhida',
                findPharmaciesCaption: 'Procure a farmácia mais próxima que o medicamento será liberado',
            },
            secondStep: {
                title: 'Liberação de medicamento',
                titleLine2: '1ª caixa',
                subtitle: 'Informe seu CPF para continuar',
            },
            thirdStep: {
                title: 'Confira Seus Dados',
                subtitle: 'VERIFIQUE SE TODAS AS INFORMAÇÕES ESTÃO CORRETAS.',
                readTerms: 'Leia aqui os termos de consentimento',
                acceptTerms: 'Confirmo que li e aceito os termos do programa',
                acceptContactSms: 'Aceito receber contato posterior por SMS',
                acceptContactEmail: 'Aceito receber contato posterior por E-mail',
                acceptContactPhone: 'Aceito receber contato posterior por telefone',
            },
            fourthStep: {
                title: 'Localize sua farmácia',
                subtitle: 'Informe seu CEP ou nome da rua com nº para buscar as farmácias mais próximas',
            },
        },
        pendingApproval: {
            title: 'Aprovação pendente',
            subtitle: 'Informaremos por email quando seu acesso for aprovado',
        },
        userRegister: {
            doctorData: 'Dados do médico',
        },
        helperText: {
            numbersOnly: 'somente números',
            password: 'A senha deve conter no mínimo 6 caracteres',
        },
        userType: {
            ADMIN: 'Admin',
            DOCTOR: 'Médico',
        },
        tooltips: {
            signupPhone: 'Importante confirmar se o telefone está correto, pois será enviado um SMS com o código validador',
        },
        accessPlatform: 'Acessar a plataforma',
        amount: 'Quantidade',
        approved: 'Aprovado',
        availableInventory: 'Estoque disponível',
        birthDate: 'Data de nascimento',
        cellphone: 'Celular',
        changePassword: 'Alterar senha',
        chooseAnotherMethod: 'Escolher outro método',
        confirm: 'Confirmar',
        confirmEmail: 'Confirme seu e-mail',
        confirmRegistration: 'Confirmar cadastro',
        confirmPassword: 'Confirmar senha',
        continue: 'Continuar',
        cpf: 'CPF',
        createAccount: 'Criar conta',
        crm: 'CRM',
        deleteAccount: 'Remover meus dados',
        email: 'E-mail',
        false: 'Não',
        female: 'Feminino',
        findPharmacies: 'Buscar farmácias',
        gender: 'Gênero',
        goBack: 'voltar',
        logout: 'Deslogar',
        male: 'Masculino',
        name: 'Nome',
        no: 'Não',
        password: 'Senha',
        presentation: 'Apresentação',
        product: 'Produto',
        profile: 'Perfil',
        register: 'Cadastrar',
        save: 'Salvar',
        search: 'Buscar',
        sendAgainIn: {
            one: 'Enviar novamente em 1 segundo',
            other: 'Enviar novamente em {{count}} segundos',
            zero: 'Enviar novamente',
        },
        sex: 'Sexo',
        sms: 'SMS',
        uf: 'UF',
        users: 'Usuários',
        true: 'Sim',
        yes: 'Sim',
    },
};
